import React, { Fragment } from 'react';
import { ProductFeatures } from '../ProductFeatures';
import { Rating } from '../../../Rating';
import { StarsSet, FeatureLabel, FeatureBadge } from './partials';
export var Ratings = function Ratings(_ref) {
  var score = _ref.score,
    catalog = _ref.catalog,
    features = _ref.features,
    show = _ref.show,
    _ref$withFeatures = _ref.withFeatures,
    withFeatures = _ref$withFeatures === void 0 ? false : _ref$withFeatures;
  return React.createElement(Fragment, null, React.createElement(StarsSet, null, React.createElement(FeatureLabel, null, withFeatures ? 'Valoración' : 'Valoración'), React.createElement(FeatureBadge, null, React.createElement(Rating, {
    size: "small",
    value: score || 0,
    isSelectable: false,
    starSize: "18",
    type: "infoStar"
  }))), withFeatures ? React.createElement(ProductFeatures, {
    catalog: catalog,
    features: features,
    show: show
  }) : null);
};